import { createRef, useEffect, useRef, useState } from 'react';

import { useMediaQuery } from '@mui/material';
import { Document, Page, pdfjs } from 'react-pdf';

import DownloadIcon from 'public/assets/download_w.svg';

pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/legacy/build/pdf.worker.min.js`;

export default function PDFViewer({ url }: { url: string }) {
  const [numPages, setNumPages] = useState(null);
  const [activePage, setActivePage] = useState(1);
  const [pageRefs, setPageRefs] = useState([]);
  const documentRef = useRef<HTMLDivElement | null>(null);
  const isMedia920px = useMediaQuery('(max-width : 920px)');
  const [windowDimension, setWindowDimension] = useState({
    height: 0,
    width: 0,
  });

  useEffect(() => {
    if (typeof window !== 'undefined') {
      const { innerWidth: width, innerHeight: height } = window;
      setWindowDimension({ width, height });
    }
  }, []);

  useEffect(() => {
    function handleDimensionChange() {
      if (typeof window !== 'undefined') {
        const { innerWidth: width, innerHeight: height } = window;
        setWindowDimension({ width, height });
      }
    }
    window.addEventListener('resize', handleDimensionChange);
    return () => window.removeEventListener('resize', handleDimensionChange);
  }, []);

  function onDocumentLoadSuccess({ numPages: nextNumPages }: any) {
    setNumPages(nextNumPages);
    const refs = [];
    for (let i = 0; i < nextNumPages; i += 1) {
      refs.push(createRef());
    }
    setPageRefs(refs);
  }

  function handleScroll() {
    let page;
    for (let i = 0; i < numPages; i += 1) {
      if (
        pageRefs[i].current.getBoundingClientRect().top <=
        documentRef.current.getBoundingClientRect().top
      ) {
        page = i;
      }
    }
    setActivePage(page + 1);
  }

  return (
    <div className="h-full w-full bg-scroll relative bg-[#525659]">
      <div className="h-12 w-full bg-[#323639] flex justify-between">
        <div className="float-right py-3 ml-4">
          <a href={url} target="_blank" download={true} rel="noreferrer">
            <img src={DownloadIcon.src} alt="Download" className="p-0 h-5" />
          </a>
        </div>
        <div className="text-white w-32 mt-2 mr-4 p-1 text-center float-right">
          Page{' '}
          <span className="bg-[#191B1C] text-center px-1"> {activePage} </span>
          of {numPages}
        </div>
      </div>
      <div
        className="overflow-auto absolute flex justify-center inset-x-0 no-scrollbar m-auto top-12 bottom-0  "
        ref={documentRef}
        onScroll={handleScroll}
      >
        <div className="max-w-full">
          <Document
            options={{
              cMapUrl: `https://unpkg.com/pdfjs-dist@${pdfjs.version}/cmaps/`,
              cMapPacked: true,
            }}
            file={url}
            onLoadSuccess={onDocumentLoadSuccess}
            loading={
              <div className="text-white border flex justify-center">
                Loading PDF ...
              </div>
            }
          >
            {Array.from({ length: numPages }, (_, index) => (
              <div className="mb-2" ref={pageRefs[index]}>
                <Page
                  key={`page_${index + 1}`}
                  pageNumber={index + 1}
                  renderAnnotationLayer={true}
                  onGetAnnotationsSuccess={console.log}
                  width={isMedia920px ? windowDimension.width - 80 : null}
                />
              </div>
            ))}
          </Document>
        </div>
      </div>
    </div>
  );
}
